import { jsx as _jsx } from "react/jsx-runtime";
import { LaborClinEditor } from './LaborClinEditor';
export function TMClinEditor(props) {
    return /*#__PURE__*/ _jsx(LaborClinEditor, {
        ...props,
        kind: "T&M"
    });
}
